import request from '@/utils/request'

/** 获取门店目标列表 */
export function getLqMdTargetList(data) {
  return request({
    url: '/api/Extend/LqMdTarget',
    method: 'get',
    data
  })
}

/** 获取门店目标详情 */
export function getLqMdTargetInfo(id) {
  return request({
    url: `/api/Extend/LqMdTarget/${id}`,
    method: 'get'
  })
}

/** 创建门店目标 */
export function createLqMdTarget(data) {
  return request({
    url: '/api/Extend/LqMdTarget',
    method: 'post',
    data
  })
}

/** 更新门店目标 */
export function updateLqMdTarget(id, data) {
  return request({
    url: `/api/Extend/LqMdTarget/${id}`,
    method: 'put',
    data
  })
}

/** 删除门店目标 */
export function deleteLqMdTarget(id) {
  return request({
    url: `/api/Extend/LqMdTarget/${id}`,
    method: 'delete'
  })
}

/** 复制上月目标到指定月份 */
export function copyLastMonthTarget(data) {
  return request({
    url: '/api/Extend/LqMdTarget/CopyLastMonth',
    method: 'post',
    data
  })
}

/** 获取门店主档（预填归属部门） */
export function getStoreMdxxInfo(id) {
  return request({
    url: `/api/Extend/LqMdxx/${id}`,
    method: 'get'
  })
}

/** 获取组织部门选项（parentId 为事业部/科技部/教育部/大项目部根节点 ID） */
export function getDepartmentOptions(parentId) {
  return request({
    url: '/api/Extend/Organize',
    method: 'get',
    data: {
      parentId,
      category: 'department',
      currentPage: 1,
      pageSize: 500
    }
  })
}

/** 获取组织/部门详情（用于回显名称） */
export function getOrganizeInfo(id) {
  return request({
    url: `/api/permission/Organize/${id}`,
    method: 'get'
  })
}
